import { Link } from 'react-router-dom';
import { Button, Anchor, TextInput, Stack, Flex } from '@mantine/core';

import CustomPasswordInput from '../../CustomPasswordInput';

import { useLogInFormContext } from '../../../contexts/forms';

import { BaseFormProps } from '../../../@types/global';

export default function LogInForm({
  onSubmit,
  isSubmitting = false,
}: BaseFormProps) {
  const form = useLogInFormContext();

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack justify="center">
        <TextInput
          size="md"
          label="Email"
          placeholder="your-email@domain.com"
          type="email"
          autoComplete="email"
          withAsterisk={false}
          disabled={isSubmitting}
          {...form.getInputProps('username')}
        />
        <div>
          <CustomPasswordInput
            size="md"
            mb="sm"
            label="Password"
            autoComplete="current-password"
            withAsterisk={false}
            disabled={isSubmitting}
            {...form.getInputProps('password')}
          />
          <Anchor size="md" component={Link} to="/forgot-password">
            Forgot your password?
          </Anchor>
        </div>
        <Flex justify="center">
          <Button type="submit" loading={isSubmitting} w={200}>
            Log In
          </Button>
        </Flex>
      </Stack>
    </form>
  );
}
